// extracted by mini-css-extract-plugin
export var carrierIcon = "_xf-0";
export var carrierLogo = "_xf-1";
export var detailsSection = "_xf-2";